import React from 'react';
import { StarRating } from '../../marketplace/components/StarRating';

export const CommunityCard = ({ community }) => {
  return (
    <div className="community-card bg-white border h-100 overflow-hidden">
      <div className="position-relative">
        <img src={community.coverImage} alt={community.title} className="img-fluid w-100 object-fit-cover" style={{ height: "170px" }} />
        {community.rank && (
          <span className="position-absolute top-0 start-0 m-2 badge bg-dark text-white fw-medium">
            #{typeof community.rank === 'string' ? community.rank : `${community.rank}`}
          </span>
        )}
      </div>
      <div className="item-info small">
        <div className="flex-grow-1 p-3">
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-2">
            <span className={`course-category badge bg-${community.categoryColor || 'primary'} bg-opacity-10 fw-medium rounded-0 text-${community.categoryColor || 'primary'} text-uppercase`}>
              {typeof community.category === 'object' ? community.category.name : (community.category || 'COMMUNITY')}
            </span>
            <span className="course-price text-base fw-semibold text-primary">
              {typeof community.price === 'string'
                ? (community.price.includes('/m') ? community.price : `${community.price}/m`)
                : (community.price > 0 ? `$${community.price}/m` : 'Free')}
            </span>
          </div>
          <div className="course-title fw-medium text-truncate-2 text-gray-900">{community.title || community.name}</div>
        </div>
        <div className="border-top d-flex flex-wrap align-items-center justify-content-between gap-2 text-gray-700 fw-medium px-3 py-2">
          <span className="ratings d-flex align-items-center gap-1">
            <StarRating rating={community.rating || 5} />
            <span className="rating-number">{(community.rating || 5).toFixed(1)}</span>
          </span>
          <span>
            {community.membersCount || 0} <span className="fw-normal text-gray-500">mebers</span>
          </span>
        </div>
      </div>
    </div>
  );
};
